// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__37RZ4","inputWrap":"Table_inputWrap__2GRLi","col":"Table_col__XrTLZ","bmiTooltip":"Table_bmiTooltip__3PFO_"};